export interface IBuyerErrorModal {
    bodyText?: string;
    title?: string;
    isShown?: boolean;
}
